
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"material-symbols:info"}},[_c('path',{attrs:{"id":"Vector","d":"M7.3335 11.8359H8.66683V7.83594H7.3335V11.8359ZM8.00016 6.5026C8.18905 6.5026 8.3475 6.4386 8.4755 6.3106C8.6035 6.1826 8.66727 6.02438 8.66683 5.83594C8.66683 5.64705 8.60283 5.4886 8.47483 5.3606C8.34683 5.2326 8.18861 5.16883 8.00016 5.16927C7.81127 5.16927 7.65283 5.23327 7.52483 5.36127C7.39683 5.48927 7.33305 5.64749 7.3335 5.83594C7.3335 6.02483 7.3975 6.18327 7.5255 6.31127C7.6535 6.43927 7.81172 6.50305 8.00016 6.5026ZM8.00016 15.1693C7.07794 15.1693 6.21127 14.9942 5.40016 14.6439C4.58905 14.2937 3.8835 13.8188 3.2835 13.2193C2.6835 12.6193 2.20861 11.9137 1.85883 11.1026C1.50905 10.2915 1.33394 9.42483 1.3335 8.5026C1.3335 7.58038 1.50861 6.71372 1.85883 5.9026C2.20905 5.09149 2.68394 4.38594 3.2835 3.78594C3.8835 3.18594 4.58905 2.71105 5.40016 2.36127C6.21127 2.01149 7.07794 1.83638 8.00016 1.83594C8.92239 1.83594 9.78905 2.01105 10.6002 2.36127C11.4113 2.71149 12.1168 3.18638 12.7168 3.78594C13.3168 4.38594 13.7919 5.09149 14.1422 5.9026C14.4924 6.71372 14.6673 7.58038 14.6668 8.5026C14.6668 9.42483 14.4917 10.2915 14.1415 11.1026C13.7913 11.9137 13.3164 12.6193 12.7168 13.2193C12.1168 13.8193 11.4113 14.2944 10.6002 14.6446C9.78905 14.9948 8.92239 15.1697 8.00016 15.1693Z","fill":"currentColor"}})])])
          )
        }
      }
    